// pages/limousine/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import CtaButton from "../../components/buttonWithArrow";
import RoiInvestorBenefits from "../../components/Investments/RoiInvestorBenefits";
import ServicesBenefits from "../../components/Investments/ServicesBenefits";
import { ALLSERVICES_page } from "../../data/all-services";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import { Box } from "@mui/material";
import PickYourCarGrid from "../../components/Investments/PickYourCarToServices";
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

export default function AllServices({ meta }) {
  const HEADER_OFFSET = 88;
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section
        className="hero"
        style={{
          position: "relative",
          width: "100%",
          height: bannerHeight(),
          overflow: "hidden",
        }}
      >
        {/* Fixed background layer */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: bannerHeight(),
            zIndex: 0,
          }}
        >
          {/* BG image */}
          <Image
            src="/img/services/banner.svg"
            alt="limousine"
            fill
            priority
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
          {/* Gradient overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              background: "linear-gradient(to top, rgb(0 0 0 / 79%) 0%, rgba(0, 0, 0, 0) 50%)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
          {/* dark gradient overlay */}
          {/* <div className="overlay" aria-hidden="true" /> */}

          {/* content */}
          <div className="content">
            <h1 className="title jura">
              Your {""}
              <span className="scribble-wrap">
                <span className="scribble-text">Journey,</span>
                {/* teal hand-drawn oval */}
                <img
                  src="/img/header/Oval.svg"
                  alt=""
                  className="scribble"
                />
              </span>{" "}
              Simplified
            </h1>

            <div className="cta">
              <CtaButton label="Download App" onClick={() => scrollToId("communicationChannel")} endIconSrc="/img/header/VectorDown.svg" />
            </div>
          </div>
        </div>
      </section>
      {/* 👇 important: push content BELOW fixed hero */}
      <Box
        id="fleet"
        sx={{
          position: "relative",
          zIndex: 3,
          pt: `${bannerHeight()}px`,
        }}
      >
        <Box id="investmentGuide" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <ServicesBenefits data={ALLSERVICES_page?.roiInvestorBenefits} onClick={() => console.log("")} />
        </Box>
        <Box id="fleet" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <PickYourCarGrid data={{
            ...ALLSERVICES_page?.carToInvestNew
          }} />
        </Box>
        <Box id="investmentGuide" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <RoiInvestorBenefits data={ALLSERVICES_page?.carToInvest} onClick={() => console.log("")} />
        </Box>
        <Box id="communicationChannel" sx={{ scrollMarginTop: { xs: '80px', md: '96px' }, background: "#fff" }}>
          <CommunicationChannel data={ALLSERVICES_page.communicationChannel} />
        </Box>
        <Footer3 bgcolor="#f8f8f8" />
      </Box>
      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(60vh, 72vh, 80vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(16px, 3vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: -0.1em;
          top: -10px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(-4deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}